import $ from 'jquery'
import BasicLightbox from '../../BasicLightbox'
import ChartDataParametersSectionController from './ChartDataParametersSectionController'
import SpinnerController from '../../SpinnerController'
import Spinner from "../../spin.min"
import messageResource from '../../messageResource'
import makeRpcCall from '../../util/jquery_rpc'
import ChartDisplayParametersSectionController from './ChartDisplayParametersSectionController'
import {ChartType, ReportChartType} from '../constants'
import ChartController from './ChartController'
import ChartDataController from './ChartDataController'
import ReportChartUtils from '../ReportChartUtils'
import BaseFormatterCreator from './parametersFormatters/BaseFormatterCreator'
import CreateChartLightboxPDFPreviewViewController from './CreateChartLightboxPDFPreviewViewController'
import {arrayToMap} from '../../atUtils'

function CreateChartLightbox() {}

CreateChartLightbox.prototype = new BasicLightbox();

CreateChartLightbox.prototype.exist_invalid_fields_message_key = "";
CreateChartLightbox.prototype.close_tab_confirmation_message_key = "";

CreateChartLightbox.prototype.init = function( config )
{
    BasicLightbox.prototype.init.call(this, config.popupId, config.closeBtnId);

    const self = this;
    this.titleEl = $(this.lightBoxEl).find(".lightBoxTitle");
    this.setCancelCallback( function() { self.hide(); } );

    this.needToReloadPageAfterClose = config.needToReloadPageAfterClose
    this.reloadPageAfterClose = false;
    this.formatter = new BaseFormatterCreator();

    this.createChartErrorEl = this.innerContent.find( ".createChartError" );

    // get display parameters from cookies only if this is new config
    if( !config.chartId )
    {
        config.chartDisplayParameters = ChartDisplayParametersSectionController.getDefaultDisplayParameters();
        $.extend( config.chartDisplayParameters, this.read_cookie( "actiTIME-CHARTDisplayParameters" ) );
    }

    this.chartDataParametersSectionController = new ChartDataParametersSectionController().init( config.popupId,
                                                                                                 config.chartPopupData,
                                                                                                 config.chartType,
                                                                                                 config.chartDataParameters,
                                                                                                 function() { self.onDataParametersChanged(); } );

    this.chartDataController = new ChartDataController().init(config.chartPoints, config.chartDisplayParameters.stackColumns)
    this.chartDisplayParametersSectionController = new ChartDisplayParametersSectionController().init(
        config.chartDisplayParameters,
        config.chartDataParameters.groupingLevel,
        this.chartDataController.getMinValue(),
        this.chartDataController.getMaxValue(),
        function(){self.displayParametersChanged();},
        config.chartPopupData.showStackColumnsCheckMark,
        )
    this.totalValueContainer = $(config.totalValueContainer);

    const chartData = {
        title: ReportChartTitle[config.chartType],
        chartPoints: config.chartPoints,
        total: this.chartDataController.getTotal(),
        max: this.chartDataController.getMaxValue(),
        min: this.chartDataController.getMinValue()
    };

    this.chartController = new ChartController().init( {
                                                           containerId: config.chartContainerId,
                                                           partsContainerId: config.partsContainerId,
                                                           data: chartData,
                                                           settings: {
                                                               showPercents: config.chartDisplayParameters.showPercents,
                                                               colorId: config.chartDisplayParameters.chartColor,
                                                               chartType: config.chartDisplayParameters.chartType,
                                                               reportChartType: config.chartType,
                                                               groupingLevel: config.chartDataParameters.groupingLevel,
                                                               sortCategoryComparator: self.getSortCategoryFunctionForChart(),
                                                               sortOption: config.chartDisplayParameters.sortOption,
                                                               sortOrder: config.chartDisplayParameters.sortOrderIsAsc,
                                                               emptyPieCallback: $.proxy(self.showChartErrorMessageWithControls, this),
                                                               stackColumns: this.chartDisplayParametersSectionController.isStackColumnsCheckboxVisibleAndChecked()
                                                           }
                                                       });
    this.showOrHideNotFullDataMessage(this.chartDataController.getMinValue(), this.chartDataController.getMaxValue());
    this.showTotalValue(this.chartDataController.getTotal(), this.formatter.getValueFormattedFunction( config.chartType ), this.formatter.getMeasureUnit(config.chartType));

    this.initPdfPreviewViewController( config );

    this.successCallback = function () {
        self.pdfPreviewViewController.switchLightboxToPDFPreviewView(
            self.chartDataParametersSectionController.getSelectedValues(),
            self.chartDisplayParametersSectionController.getChartType(),
            self.chartDataController
        )
    };

    this.initConfig = this.getReportConfig();

    self.chartId = config.chartId;

    this.saveConfigControl = new SaveConfigurationControl().init(
            {
                reportName: config.chartName,
                hasChanges: false
            },
            SaveConfigurationControl.CHART_TYPE,
            function(reportName) {
                const reportConfig = self.getReportConfig();
                reportConfig.reportName = reportName;
                self.saveChartManager.saveReport( reportConfig )
            },
            function(reportName) {
                const reportConfig = self.getReportConfig();
                reportConfig.reportId = self.chartId;
                reportConfig.reportName = reportName;
                self.saveChartManager.updateReport( reportConfig )
            },
            function() {
                return self.resetConfig();
            }
    );
    this.saveChartManager = new SaveReportChartManager().init(
            this.saveConfigControl,
            function( reportId )
            {
                if( reportId )
                    self.chartId = reportId;
                self.initConfig = self.getReportConfig();
                $(document).trigger("chartSaved", { chartId: self.chartId })
                self.reloadPageAfterClose = this.needToReloadPageAfterClose ? true : false;
            },
            function( errorThrown )
            {
                // default
                return false;
            }
    );

    if ( config.makeChartPointsException )
        this.handleMakeChartPointsException( config.makeChartPointsException );
    else if ( config.chartPoints.length === 0 )
        this.showEmptyChartDataMessage();
    else if ( config.chartDisplayParameters.chartType === ChartType.PIE_CHART && chartData.max === 0 && chartData.min === 0)
        this.showChartErrorMessageWithControls();
    else
        this.removeChartErrorMessage();

    const spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 8, // The length of each line
        width: 3, // The line thickness
        radius: 6, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#888888', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    this.spinnerController = new SpinnerController();
    this.spinnerController.setSpinner( new Spinner( spinnerOptions ) );

    this.switchLightboxToCreateChartView();
    this.updateLightboxChartTypeClass();

    return this;
};

CreateChartLightbox.prototype.extractReportAuthorizationInfo = function({chartsAuthorizationInfo, chartType}) {
    let reportAuthInfo = null
    switch (chartType) {
        case ReportChartType.TOTAL_WORKING_HOURS:
        case ReportChartType.APPROVED_WORKING_HOURS:
            reportAuthInfo = chartsAuthorizationInfo.taskChartsAuthorizationInfo
            break
        case ReportChartType.COST_OF_WORK:
        case ReportChartType.BILLABLE_AMOUNTS:
            reportAuthInfo = chartsAuthorizationInfo.billingChartsAuthorizationInfo
            break
        case ReportChartType.LEAVE_HOURS:
        case ReportChartType.PTO_BALANCE:
        case ReportChartType.SICK_DAYS_BALANCE:
        case ReportChartType.OVERTIME_HOURS:
            reportAuthInfo = chartsAuthorizationInfo.balanceChartsAuthorizationInfo
            break
    }
    return chartsAuthorizationInfo
}

CreateChartLightbox.prototype.initPdfPreviewViewController = function(config) {
    const reportAuthInfo = this.extractReportAuthorizationInfo({
        chartsAuthorizationInfo: config.chartPopupData.chartsAuthorizationInfo,
        chartType: config.chartType,
    })

    this.pdfPreviewViewController = new CreateChartLightboxPDFPreviewViewController().init(
        this.lightBoxEl,
        this.titleEl,
        config.popupId,
        config.chartPopupData.printParameters,
        () => { this.switchLightboxToCreateChartView() },
        this.chartController,
        {
            users: config.chartPopupData.users,
            enabledFeatures: config.chartPopupData.enabledFeatures,
            userGroups: config.chartPopupData.userGroups,
            timeZoneGroups: config.chartPopupData.timeZoneGroups,
            customersProjects: config.chartPopupData.customersProjects,
            leaveTypesMap: arrayToMap(config.chartPopupData.leaveTypes),
            manageableUserIds: config.chartPopupData.manageableUsersIds,
            projectsWithMaIds: config.chartPopupData.projectsWithMaIds,
        },
        () => this.chartDataParametersSectionController.includeOtherUsers(),
        () => this.chartDisplayParametersSectionController.isStackColumnsCheckboxVisibleAndChecked(),
        reportAuthInfo,
)
}

CreateChartLightbox.prototype.hide = function ()
{
    this.cancelAllExportingProcesses();
    this.abortMakeChartPointsRequest();
    BasicLightbox.prototype.hide.call(this);

    if ( this.reloadPageAfterClose )
        document.location.reload();

    $(document).trigger("reportCharts.createChartLightbox.hide"); // private of CreateChartLightboxPDFPreviewViewController, can't reuse without refactoring
    $(document).trigger("chartClosed", { chartId: this.chartId });
};

CreateChartLightbox.prototype.showTotalValue = function( value, formatter, unit ){
    this.totalValueContainer.html( formatter( value ) + "&nbsp;" + unit);
};

CreateChartLightbox.prototype.getReportConfig = function()
{
    return {
        reportType: this.chartDataParametersSectionController.getChartType(),
        reportParameters: {
            dataParameters: this.chartDataParametersSectionController.getSelectedParams(),
            displayParameters: this.chartDisplayParametersSectionController.getDisplayParameters()
        }
    };
};

CreateChartLightbox.prototype.resetConfig = function()
{
    this.chartDataParametersSectionController.setParameters(
            this.initConfig.reportType,
            this.initConfig.reportParameters.dataParameters
    );
    this.chartDisplayParametersSectionController.setParameters(
            this.initConfig.reportParameters.displayParameters,
            this.initConfig.reportParameters.dataParameters.groupingLevel
    );
    this.displayParametersChanged();
    this.onDataParametersChanged();
    return true;
};


CreateChartLightbox.prototype.displayParametersChanged = function() {
    this.updateLightboxChartTypeClass()
    this.write_cookie("actiTIME-CHARTDisplayParameters", this.chartDisplayParametersSectionController.getDisplayParameters())
    this.saveConfigControl.registerConfigChanged()
    this.removeChartErrorMessage()
    this.chartController.updateDisplayData(
        {
            chartType: this.chartDisplayParametersSectionController.getChartType(),
            colorId: this.chartDisplayParametersSectionController.getChartColorId(),
            sortOption: this.chartDisplayParametersSectionController.getSortOption().by,
            sortOrder: this.chartDisplayParametersSectionController.getSortOption().isAsc,
            isShowPercents: this.chartDisplayParametersSectionController.changeCheckboxStateIfNeededAndGetShowPercentsValue(
                this.chartDataController.getMinValue(),
                this.chartDataController.getMaxValue()
            ),
            stackColumns: this.chartDisplayParametersSectionController.changeCheckboxStateIfNeededAndGetShowShowStackedColumnsValue(),
        }
    )
}

CreateChartLightbox.prototype.updateLightboxChartTypeClass = function ()
{
    const chartType = this.chartDisplayParametersSectionController.getChartType();
    let cssClass = "";
    switch (chartType) {
        case ChartType.VERTICAL_BAR:
            cssClass = "verticalBar"; break;
        case ChartType.HORIZONTAL_BAR:
            cssClass = "horizontalBar"; break;
        case ChartType.PIE_CHART:
            cssClass = "pieChart";
    }
    $(this.lightBoxEl).removeClass("verticalBar horizontalBar pieChart" ).addClass(cssClass);
};

CreateChartLightbox.prototype.onDataParametersChanged = function()
{
    this.abortMakeChartPointsRequest();

    if ( !this.chartDataParametersSectionController.validate() )
    {
        this.saveConfigControl.disableEditConfig();
        this.printErrorInFooter( this.chartDataParametersSectionController.getUnescapedErrorMessage() );
        this._blinkErrorInFooter();
        this.showChartErrorMessage( messageResource.getMessage( "report.create_chart.error.params_not_valid" ) );
        return;
    }

    this.saveConfigControl.enableEditConfig();
    this.removeErrorInFooter();
    this.removeChartErrorMessage();
    this.showLoadingChartSpinner();

    const self = this;
    const newChartType = this.chartDataParametersSectionController.getChartType();
    const newParams = this.chartDataParametersSectionController.getSelectedParams();
    this.saveConfigControl.registerConfigChanged();
    this.makeChartPointsRequestObject = makeRpcCall("ReportChartService.makeChartPoints",
                [newChartType, newParams],
                function ( result )
                {
                    self.hideLoadingChartSpinner();
                    if ( result && result.length > 0 )
                    {
                        self.chartDisplayParametersSectionController.changeSortClassAccordingGroupingLevel(newParams.groupingLevel);
                        self.chartDisplayParametersSectionController.changeCheckboxStateIfNeededAndGetShowShowStackedColumnsValue()
                        const stackColumns = self.chartDisplayParametersSectionController.isStackColumnsCheckboxVisibleAndChecked()
                        self.chartDataController.updateData(result, stackColumns);
                        self.chartController.updateData({
                                title: ReportChartTitle[newChartType],
                                chartPoints: result,
                                total: self.chartDataController.getTotal(),
                                max: self.chartDataController.getMaxValue(),
                                min: self.chartDataController.getMinValue()
                            },
                            {
                                groupingLevel: newParams.groupingLevel,
                                reportChartType: newChartType,
                                sortOption: self.chartDisplayParametersSectionController.getSortOption().by,
                                sortOrder: self.chartDisplayParametersSectionController.getSortOption().isAsc,
                                sortCategoryComparator: self.getSortCategoryFunctionForChart(),
                                isShowPercents: self.chartDisplayParametersSectionController.changeCheckboxStateIfNeededAndGetShowPercentsValue(
                                    self.chartDataController.getMinValue(), self.chartDataController.getMaxValue()),
                                stackColumns: stackColumns,
                            }
                        )
                        self.showOrHideNotFullDataMessage(self.chartDataController.getMinValue(), self.chartDataController.getMaxValue());
                        self.showTotalValue(self.chartDataController.getTotal(), self.formatter.getValueFormattedFunction(newChartType), self.formatter.getMeasureUnit(newChartType))
                    }
                    else
                    {
                        self.showEmptyChartDataMessage();
                    }
                },
                function (jqXHR, textStatus, errorThrown)
                {
                    if ( textStatus === 'rpc_sessionExpired' ||  textStatus === 'rpc_noRights' )
                        return false;

                    self.hideLoadingChartSpinner();

                    if( textStatus === "abort" )
                        return true;

                    if( textStatus === "timeout" )
                    {
                        self.showChartErrorMessage( messageResource.getMessage( "report.create_chart.error.timeout" ) );
                        return true;
                    }

                    return self.handleMakeChartPointsException( errorThrown.exception );
                }
    );
};

CreateChartLightbox.prototype.abortMakeChartPointsRequest = function()
{
    if( this.makeChartPointsRequestObject )
        this.makeChartPointsRequestObject.abort();
};

CreateChartLightbox.prototype.handleMakeChartPointsException = function( exception )
{
    if( exception === 'com.actimind.actitime.reports.AllSelectedProjectsAreUnavailableException' )
    {
        this.showChartErrorMessage( messageResource.getEscapedMessage( "report.create_chart.error.no_selected_projects" ) );
        return true;
    }
    if( exception === 'com.actimind.actitime.reports.AllSelectedUsersWereDeletedException' )
    {
        this.showChartErrorMessage( messageResource.getMessage( "report.create_chart.error.no_selected_users" ) );
        return true;
    }
    if( exception === 'com.actimind.actitime.reports.NoSelectedUsersWithEnabledOvertimeException' )
    {
        this.showChartErrorMessage( messageResource.getMessage( "report.create_chart.error.no_selected_overtime_users" ) );
        return true;
    }
    if( exception === 'com.actimind.actitime.reports.charts.NoPtoUsersSelectedException' )
    {
        this.showChartErrorMessage( messageResource.getMessage( "report.create_chart.error.no_selected_pto_users" ) );
        return true;
    }
    if( exception === 'com.actimind.actitime.reports.charts.NoSickUsersSelectedException' )
    {
        this.showChartErrorMessage( messageResource.getMessage( "report.create_chart.error.no_selected_sick_users" ) );
        return true;
    }
    if( exception === 'com.actimind.actitime.reports.AllSelectedLeaveTypesWereDeletedException' )
    {
        this.showChartErrorMessage( messageResource.getMessage( "report.create_chart.error.no_selected_leave_types" ) );
        return true;
    }
    if( exception === 'com.actimind.actitime.reports.NoBillableTasksException' )
    {
        this.showChartErrorMessage( messageResource.getEscapedMessage( "report.create_chart.error.no_billable_tasks" ) );
        return true;
    }

    this.showChartErrorMessage( messageResource.getMessage( "report.create_chart.error.unexpected_error" ) );
    return false;
};

CreateChartLightbox.prototype.getSortCategoryFunctionForChart = function() {
    const groupingLevel = this.chartDataParametersSectionController.getGroupingLevel();
    return ReportChartUtils.getSortCategoryFunctionForChart(groupingLevel);
};

CreateChartLightbox.prototype.changeShowPercents = function( checked )
{
    this.chartController.changeShowPercents( checked );
};

CreateChartLightbox.prototype.changeStackColumns = function( checked )
{
    this.chartController.changeStackColumns( checked );
};

CreateChartLightbox.prototype.validate = function ()
{
    return this.chartDataParametersSectionController.validate();
};

CreateChartLightbox.prototype.updateUI = function ()
{
    return this.chartDataParametersSectionController.updateUI();
};

CreateChartLightbox.prototype.switchLightboxToCreateChartView = function ()
{
    this.cancelAllExportingProcesses();
    $( this.lightBoxEl ).removeClass("pdfPreviewMode").addClass("createChartMode");
    this.titleEl.text( messageResource.getMessage("report.create_chart.title") );
};

CreateChartLightbox.prototype.cancelAllExportingProcesses = function ()
{
    this.pdfPreviewViewController.cancelAllExportingProcesses();
};

CreateChartLightbox.prototype.showEmptyChartDataMessage = function ()
{
    this.showChartErrorMessage( messageResource.getMessage( "report.create_chart.error.empty_result_data" ) );
};

CreateChartLightbox.prototype.showChartErrorMessage = function ( errorMessage )
{
    this.createChartErrorEl.find(".createChartErrorMessage" ).html( errorMessage );
    this.innerContent.addClass("inErrorState");
    this.disableCommitButton();
};

CreateChartLightbox.prototype.showChartErrorMessageWithControls = function ( )
{
    this.createChartErrorEl.find(".createChartErrorMessage" ).html( messageResource.getMessage( "report.create_chart.error.empty_result_data" ) );
    this.innerContent.addClass("emptyPieState");
    this.disableCommitButton();
};


CreateChartLightbox.prototype.removeChartErrorMessage = function ()
{
    this.innerContent.removeClass("inErrorState");
    this.innerContent.removeClass("emptyPieState");
    this.enableCommitButton();
};

CreateChartLightbox.prototype.showLoadingChartSpinner = function ()
{
    this.innerContent.addClass("inLoadingState");
    this.spinnerController.spinInElement( this.innerContent.find( ".createChartSpinnerPlaceholder" ) );
    this.disableCommitButton();
};

CreateChartLightbox.prototype.hideLoadingChartSpinner = function ()
{
    this.innerContent.removeClass("inLoadingState");
    this.spinnerController.stop();
    this.enableCommitButton();
};

CreateChartLightbox.prototype.disableCommitButton = function ()
{
    this._commitEnabled = false;
    $( this.commitButton ).addClass( 'disabled' );
};

CreateChartLightbox.prototype.enableCommitButton = function ()
{
    this._commitEnabled = true;
    $( this.commitButton ).removeClass( 'disabled' );
};

CreateChartLightbox.prototype.write_cookie = function(name, value) {
    $.cookie(name,  JSON.stringify(value));
};

CreateChartLightbox.prototype.read_cookie = function(name) {
    return JSON.parse($.cookie(name));
};

CreateChartLightbox.prototype.showOrHideNotFullDataMessage = function ( minValue, maxValue ) {
    if (minValue < 0 && maxValue > 0)
        $("#infoMessageLine" ).html(messageResource.getMessage( "report.create_chart.negative_values_are_missed_message" ) );
    else
        $("#infoMessageLine" ).html("");
};

CreateChartLightbox.prototype.showOrHideNotFullDataMessage = function ( minValue, maxValue ) {
    if (minValue < 0 && maxValue > 0)
        $("#infoMessageLine" ).html(messageResource.getMessage( "report.create_chart.negative_values_are_missed_message" ) );
    else
        $("#infoMessageLine" ).html("");
};

export default CreateChartLightbox


// WEBPACK FOOTER //
// ./web/js/reports/charts/CreateChartLightbox.js